import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { deleteDestination, fetchDestinations } from '../../features/common/popularDestinationsSlice';
import { Link } from 'react-router-dom';
import { fetchPopularDestinations } from '../../features/common/popularDestinationsSlice';



const PopularAirPortDestination = () => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const { destinations, loading, error } = useSelector((state) => state.populardestination);


    useEffect(() => {
        dispatch(fetchPopularDestinations());
    }, [dispatch]);

    const filteredDestinations = destinations?.filter(
        (destination) =>
            destination.id.toString().includes(searchTerm) ||
            destination.from_city.toLowerCase().includes(searchTerm.toLowerCase()) ||
            destination.to_city.toLowerCase().includes(searchTerm.toLowerCase()) ||
            destination.from_city_airport.toLowerCase().includes(searchTerm.toLowerCase()) ||
            destination.flight_category.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleDelete = (id) => {
        setSelectedDestinationId(id);
        setShowModal(true);
    };

    const confirmDelete = () => {
        dispatch(deleteDestination(selectedDestinationId));
        setShowModal(false);
    };


    const closeModal = () => {
        setShowModal(false);
    };


    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    // Table rows to show per page Start

    const indexOfLastPackage = currentPage * rowsPerPage;
    const indexOfFirstPackage = indexOfLastPackage - rowsPerPage;
    const currentPackages = filteredDestinations.slice(indexOfFirstPackage, indexOfLastPackage);

    // bottom pagination start

    const totalPages = Math.ceil(filteredDestinations.length / rowsPerPage);

    const renderPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 3;

        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first 3 pages
            pages.push(1, 2, 3);

            // Show "..." if currentPage is beyond 5
            if (currentPage > 5) {
                pages.push("...");
            }

            // Show current page and neighbors
            const start = Math.max(4, currentPage - 1);
            const end = Math.min(totalPages - 3, currentPage + 1);

            for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) pages.push(i);
            }

            // Show "..." if currentPage is far from end
            if (currentPage < totalPages - 4) {
                pages.push("...");
            }

            // Always show last 3 pages
            pages.push(totalPages - 2, totalPages - 1, totalPages);
        }

        return pages.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
            >
                {page === "..." ? (
                    <span className="page-link">...</span>
                ) : (
                    <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                    </button>
                )}
            </li>
        ));
    };


    return (
        <div className="content-wrapper">

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Popular AirPort Destination </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Popular AirPort Destination</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">

                                <div className="card-header">
                                    <div className="d-md-flex align-items-center justify-content-end">
                                        <Link to="/add-popular-airPort-destination" className="btn btn-primary mb-md-0 mb-2 py-1 mr-3">
                                            <i className="fas fa-plus" /> Add Airport Destinations
                                        </Link>
                                        <div className="card-tools">
                                            <div
                                                className="input-group input-group-sm"
                                                style={{ width: "250px" }}
                                            >
                                                <input
                                                    type="text"
                                                    name="table_search"
                                                    className="form-control float-right"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">

                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    setRowsPerPage(parseInt(e.target.value));
                                                    setCurrentPage(1); // Reset to first page
                                                }}
                                                className="form-control mx-2 form-select d-inline-block w-auto"
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <span className="ms-2">entries</span>
                                        </div>
                                        <div>
                                            {/* Optional: Add search or pagination controls here */}
                                        </div>
                                    </div>

                                    <div className="table-responsive">


                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>From City</th>
                                                    <th>To City</th>
                                                    <th>Flight category</th>
                                                    <th>Status</th>
                                                    <th style={{ width: "15%" }}>Action</th>
                                                </tr>
                                            </thead>

                                            {currentPackages?.length > 0 ? (
                                                <tbody>
                                                    {currentPackages?.map((destination, i) => (
                                                        <tr key={destination.id}>
                                                            <td>{i + 1}</td>
                                                            <td>{destination.from_city}</td>
                                                            <td>{destination.to_city}</td>
                                                            <td style={{ textTransform: 'capitalize' }}>{destination.flight_category}</td>
                                                            <td>
                                                                <span
                                                                    className={`badge p-2 w-100 ${destination?.status === "active"
                                                                        ? "badge-success"
                                                                        : "badge-danger"
                                                                        }`}
                                                                >
                                                                    {destination?.status?.toUpperCase()}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                    <Link to={`/edit-popular-airPort-destination/${destination.id}`}>
                                                                        <button className="btn btn-primary btn-sm">
                                                                            Edit
                                                                        </button>
                                                                    </Link>

                                                                    <button
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => handleDelete(destination.id)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            </td>
                                                            <td>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            No Data found
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}




                                        </table>


                                    </div>

                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstPackage + 1} to {Math.min(indexOfLastPackage, filteredDestinations.length)} of {filteredDestinations.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {renderPageNumbers()}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center p-4">
                        <h5>Are you sure you want to delete this Destinations?</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirmDelete}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default PopularAirPortDestination;